import { Card, Space } from 'antd'
import React from 'react'
import { useParams } from 'react-router-dom';

const JobCard = ({role}) => {
  const { key } = useParams();
  return (
    <Card style={{backgroundColor: '#F4F8FF'}} bodyStyle={{minHeight: '170px', display: 'flex', flexDirection: 'column',justifyContent: 'space-between'}}>
        <div>
          <Space align='center' style={{width: '100%', justifyContent: 'space-between'}}>
            <span style={{textTransform: 'capitalize'}}>{role?.empType}</span>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <svg stroke="#aaa" fill="#aaa" strokeWidth="0" viewBox="0 0 512 512" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg"><circle cx="256" cy="192" r="32"></circle><path d="M256 32c-88.22 0-160 68.65-160 153 0 40.17 18.31 93.59 54.42 158.78 29 52.34 62.55 99.67 80 123.22a31.75 31.75 0 0 0 51.22 0c17.42-23.55 51-70.88 80-123.22C397.69 278.61 416 225.19 416 185c0-84.35-71.78-153-160-153zm0 224a64 64 0 1 1 64-64 64.07 64.07 0 0 1-64 64z"></path></svg>
              <span>
                {
                  role?.locations?.join(',')
                }
              </span>
            </div>
          </Space>
          <h3 style={{marginBlock: '10px', textTransform: 'capitalize'}}>{role?.title}</h3>
        </div>
        <a href={`/app/home/job-details/${role?.slug}${key && `?key=${key}`}`} target='_blank' rel="noreferrer" style={{display: 'flex', alignItems: 'center', color: '#3e79f7'}}>
          <span>Apply</span>
          <svg style={{marginTop: '5px', marginLeft: '2px'}} stroke="#3e79f7" fill="none" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true" height="20px" width="20px" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6"></path></svg>
        </a>
    </Card>
  )
}

export default JobCard